'use client'

import textBodySStrong from '@fukku/styles/texts/textBodySStrong.module.css'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'
import { useSizes } from '../../contexts/SizesProvider/SizesProvider'
import styles from './ErrorMessageSlot.module.css'

export function ErrorMessageSlot({
	className,
}: {
	readonly className?: string
}): React.ReactNode {
	const { t } = useLabels()
	const { hasErrorMessage } = useSizes()
	return (
		<div className={cx(styles.errorMessageSlot, className)} aria-live='polite'>
			{hasErrorMessage && (
				<p className={textBodySStrong.className}>
					{t('pdp.sizeSelector.errormessage')}
				</p>
			)}
		</div>
	)
}
